/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from 'styled-components'
import VerticalView from './VerticalView'
import GeneralBarChart from '../component/GeneralBarChart'
import UnitGroupSelection from './UnitGroupSelection'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { Content, FullHeightSizer } from 'core/screen-util'
const Container = styled.div`
  padding-left: 1em;
  padding-right: 1em;
`

const BarChart = ({ keys, retrieveDataByUnit, retrieveDataByGroup }) => (
  <Container>
    <FullHeightSizer heightOffset={170}>
      {({ height, width }) => (
        <Content css={{ height: height - 20, paddingTop: '10px' }}>
          <UnitGroupSelection
            retrieveByUnit={retrieveDataByUnit}
            retrieveByGroup={retrieveDataByGroup}
          />

          <GeneralBarChart
            keys={keys}
            Chart={VerticalView}
            screenSize={{ height: height, width }}
          />
        </Content>
      )}
    </FullHeightSizer>
  </Container>
)

export default connect(null, actions)(BarChart)
